<template>
  <div class="page-wrapper">
    <!-- PC 端 -->
    <div class="pc-version">
      <div class="coupon-table-container" v-loading="loading">
        <div class="search-bar">
          <el-select
            v-model="searchParams.type"
            placeholder="配置类型"
            clearable
            style="width: 200px"
          >
            <el-option label="字符串" :value="1"></el-option>
            <el-option label="数组" :value="2"></el-option>
          </el-select>

          <el-button type="primary" icon="el-icon-search" @click="getList"
            >搜索</el-button
          >
          <el-button icon="el-icon-refresh" @click="resetSearch"
            >重置</el-button
          >
          <el-button type="success" icon="el-icon-plus" @click="handleAdd"
            >新增</el-button
          >
        </div>

        <el-table
          :data="tableData"
          border
          stripe
          style="width: 100%; margin-top: 20px"
          @row-click="handleRowClick"
        >
          <el-table-column label="ID" prop="id" width="80" align="center" />
          <el-table-column label="配置名称" prop="cn_name" min-width="180" />
          <el-table-column label="配置标识" prop="en_name" min-width="180" />
          <el-table-column
            label="配置值"
            prop="system_value"
            min-width="120"
            align="center"
          />
          <el-table-column
            label="配置类型"
            prop="type"
            width="100"
            align="center"
          >
            <template slot-scope="scope">
              <span>{{ scope.row.type == 1 ? "字符串" : "数组" }}</span>
            </template>
          </el-table-column>
          <el-table-column label="创建时间" prop="created_at" width="180" />
          <el-table-column label="更新时间" prop="updated_at" width="180" />
          <el-table-column label="操作" width="180" align="center">
            <template slot-scope="scope">
              <el-button
                type="text"
                icon="el-icon-edit"
                @click.native.stop="handleEdit(scope.row)"
                >编辑</el-button
              >
              <el-button
                type="text"
                icon="el-icon-delete"
                style="color: #f56c6c"
                @click.native.stop="handleDelete(scope.row)"
                >删除</el-button
              >
            </template>
          </el-table-column>
        </el-table>

        <el-pagination
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          :current-page="searchParams.page"
          :page-size="searchParams.page_size"
          layout="total, sizes, prev, pager, next, jumper"
          :total="pageInfo.total"
          style="margin-top: 20px; text-align: right"
        ></el-pagination>

        <!-- PC 新增/编辑弹窗 -->
        <el-dialog
          :title="isEdit ? '编辑配置' : '新增配置'"
          :visible.sync="dialogVisible"
          width="600px"
          @close="resetForm"
          append-to-body
        >
          <el-form
            :model="form"
            :rules="rules"
            ref="formRef"
            label-width="120px"
          >
            <el-form-item label="配置名称" prop="cn_name">
              <el-input
                v-model="form.cn_name"
                placeholder="请输入中文名称"
              ></el-input>
            </el-form-item>
            <el-form-item label="配置标识" prop="en_name">
              <el-input
                v-model="form.en_name"
                placeholder="请输入英文标识"
              ></el-input>
            </el-form-item>
            <el-form-item label="配置值" prop="system_value">
              <el-input
                v-model="form.system_value"
                placeholder="请输入配置值"
                type="textarea"
                :rows="3"
              ></el-input>
            </el-form-item>
            <el-form-item label="配置类型" prop="type">
              <el-select v-model="form.type" placeholder="请选择类型">
                <el-option label="字符串" :value="1"></el-option>
                <el-option label="数组" :value="2"></el-option>
              </el-select>
            </el-form-item>
          </el-form>
          <div slot="footer" class="dialog-footer">
            <el-button @click="dialogVisible = false">取消</el-button>
            <el-button type="primary" @click="submitForm">确认提交</el-button>
          </div>
        </el-dialog>

        <!-- PC 详情弹窗 -->
        <el-dialog
          title="配置详情"
          :visible.sync="detailVisible"
          width="700px"
          append-to-body
        >
          <el-form :model="detailForm" label-width="120px" size="small">
            <el-form-item label="ID"
              ><span>{{ detailForm.id }}</span></el-form-item
            >
            <el-form-item label="配置名称"
              ><span>{{ detailForm.cn_name }}</span></el-form-item
            >
            <el-form-item label="配置标识"
              ><span>{{ detailForm.en_name }}</span></el-form-item
            >
            <el-form-item label="配置值"
              ><span>{{ detailForm.system_value }}</span></el-form-item
            >
            <el-form-item label="配置类型">
              <span>{{ detailForm.type == 1 ? "字符串" : "数组" }}</span>
            </el-form-item>
            <el-form-item label="创建时间"
              ><span>{{ detailForm.created_at }}</span></el-form-item
            >
            <el-form-item label="更新时间"
              ><span>{{ detailForm.updated_at }}</span></el-form-item
            >
          </el-form>
          <div slot="footer">
            <el-button @click="detailVisible = false">关闭</el-button>
          </div>
        </el-dialog>
      </div>
    </div>

    <!-- 移动端 -->
    <div class="mobile-version">
      <div class="mobile-coupon-container" v-loading="loading">
        <div class="mobile-search-group">
          <el-select
            v-model="searchParams.type"
            placeholder="配置类型"
            clearable
            size="medium"
            style="flex: 1"
          >
            <el-option label="字符串" :value="1"></el-option>
            <el-option label="数组" :value="2"></el-option>
          </el-select>

          <div style="display: flex; gap: 8px; margin-top: 8px">
            <el-button
              type="primary"
              plain
              round
              @click="getList"
              style="flex: 1"
              >搜索</el-button
            >
            <el-button plain round @click="resetSearch" style="flex: 1"
              >重置</el-button
            >
            <el-button
              type="success"
              plain
              round
              @click="openMobileAdd"
              style="flex: 1"
              >添加</el-button
            >
          </div>
        </div>

        <!-- 移动端卡片列表 -->
        <div class="mobile-card-list">
          <div
            class="mobile-card"
            v-for="item in tableData"
            :key="item.id"
            @click="openMobileDetail(item)"
          >
            <div class="card-header">
              <div class="info">
                <div class="title">{{ item.cn_name }}</div>
                <div class="meta">ID:{{ item.id }} | {{ item.en_name }}</div>
              </div>
              <div class="type-tag" :class="item.type == 1 ? 'type1' : 'type2'">
                {{ item.type == 1 ? "字符串" : "数组" }}
              </div>
            </div>
            <div class="card-body">
              <div>配置值：{{ item.system_value }}</div>
              <div>创建：{{ item.created_at }}</div>
            </div>
            <div class="card-footer">
              <el-button
                size="mini"
                type="primary"
                round
                @click.stop="openMobileEdit(item)"
                >编辑</el-button
              >
              <el-button
                size="mini"
                type="danger"
                round
                @click.stop="handleDelete(item)"
                >删除</el-button
              >
            </div>
          </div>
        </div>

        <!-- ========== 新增移动端分页 ========== -->
        <el-pagination
          class="mobile-pagination"
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          :current-page="searchParams.page"
          :page-size="searchParams.page_size"
          :total="pageInfo.total"
          layout="total, prev, pager, next, jumper"
          pager-count="2"
          small
        />

        <!-- 移动端详情 -->
        <el-dialog
          title="配置详情"
          :visible.sync="mobileDetailVisible"
          width="90%"
          append-to-body
          class="mobile-dialog"
        >
          <el-form :model="mobileDetailRow" label-width="100px" size="small">
            <el-form-item label="ID"
              ><span>{{ mobileDetailRow.id }}</span></el-form-item
            >
            <el-form-item label="名称"
              ><span>{{ mobileDetailRow.cn_name }}</span></el-form-item
            >
            <el-form-item label="标识"
              ><span>{{ mobileDetailRow.en_name }}</span></el-form-item
            >
            <el-form-item label="配置值"
              ><span>{{ mobileDetailRow.system_value }}</span></el-form-item
            >
            <el-form-item label="类型">
              <span>{{ mobileDetailRow.type == 1 ? "字符串" : "数组" }}</span>
            </el-form-item>
            <el-form-item label="创建时间"
              ><span>{{ mobileDetailRow.created_at }}</span></el-form-item
            >
            <el-form-item label="更新时间"
              ><span>{{ mobileDetailRow.updated_at }}</span></el-form-item
            >
          </el-form>
          <div slot="footer">
            <el-button @click="mobileDetailVisible = false">关闭</el-button>
          </div>
        </el-dialog>

        <!-- 移动端添加 -->
        <el-dialog
          title="添加配置"
          :visible.sync="mobileAddVisible"
          width="95%"
          top="10vh"
          append-to-body
          class="mobile-dialog"
        >
          <el-form
            :model="mobileAddForm"
            :rules="rules"
            ref="mobileAddRef"
            label-width="100px"
            size="small"
          >
            <el-form-item label="配置名称" prop="cn_name">
              <el-input v-model="mobileAddForm.cn_name" size="medium" />
            </el-form-item>
            <el-form-item label="配置标识" prop="en_name">
              <el-input v-model="mobileAddForm.en_name" size="medium" />
            </el-form-item>
            <el-form-item label="配置值" prop="system_value">
              <el-input
                v-model="mobileAddForm.system_value"
                type="textarea"
                :rows="3"
                size="medium"
              />
            </el-form-item>
            <el-form-item label="配置类型" prop="type">
              <el-select v-model="mobileAddForm.type" size="medium">
                <el-option label="字符串" :value="1"></el-option>
                <el-option label="数组" :value="2"></el-option>
              </el-select>
            </el-form-item>
          </el-form>
          <div
            slot="footer"
            style="display: flex; justify-content: flex-end; gap: 10px"
          >
            <el-button size="medium" @click="mobileAddVisible = false"
              >取消</el-button
            >
            <el-button type="primary" size="medium" @click="submitMobileAdd"
              >保存</el-button
            >
          </div>
        </el-dialog>

        <!-- 移动端编辑 -->
        <el-dialog
          title="编辑配置"
          :visible.sync="mobileEditVisible"
          width="95%"
          top="10vh"
          append-to-body
          class="mobile-dialog"
        >
          <el-form
            :model="mobileEditForm"
            :rules="editRules"
            ref="mobileEditRef"
            label-width="100px"
            size="small"
          >
            <el-form-item label="配置名称">
              <el-input
                v-model="mobileEditForm.cn_name"
                disabled
                size="medium"
              />
            </el-form-item>
            <el-form-item label="配置标识">
              <el-input
                v-model="mobileEditForm.en_name"
                disabled
                size="medium"
              />
            </el-form-item>
            <el-form-item label="配置值" prop="system_value">
              <el-input
                v-model="mobileEditForm.system_value"
                type="textarea"
                :rows="3"
                size="medium"
              />
            </el-form-item>
          </el-form>
          <div
            slot="footer"
            style="display: flex; justify-content: flex-end; gap: 10px"
          >
            <el-button size="medium" @click="mobileEditVisible = false"
              >取消</el-button
            >
            <el-button type="primary" size="medium" @click="submitMobileEdit"
              >保存</el-button
            >
          </div>
        </el-dialog>
      </div>
    </div>
  </div>
</template>

<script>
import api from "../../api/api.js";
export default {
  name: "SysConfig",
  data() {
    return {
      loading: false,
      tableData: [],
      pageInfo: { total: 0 },
      searchParams: { page: 1, page_size: 10, type: "" },
      dialogVisible: false,
      isEdit: false,
      form: {
        id: "",
        cn_name: "",
        en_name: "",
        system_value: "",
        type: "",
      },
      rules: {
        cn_name: [
          { required: true, message: "请输入配置名称", trigger: "blur" },
        ],
        en_name: [
          { required: true, message: "请输入配置标识", trigger: "blur" },
        ],
        system_value: [
          { required: true, message: "请输入配置值", trigger: "blur" },
        ],
        type: [
          { required: true, message: "请选择配置类型", trigger: "change" },
        ],
      },
      editRules: {
        system_value: [
          { required: true, message: "请输入配置值", trigger: "blur" },
        ],
      },
      detailVisible: false,
      detailForm: {},

      // 移动端
      mobileDetailVisible: false,
      mobileDetailRow: {},
      mobileAddVisible: false,
      mobileAddForm: {},
      mobileEditVisible: false,
      mobileEditForm: {},
    };
  },
  created() {
    this.getList();
  },
  methods: {
    // 获取列表
    getList() {
      this.loading = true;
      api.sysConfig
        .index({ params: this.searchParams })
        .then((res) => {
          if (res.data.code == 1000) {
            this.tableData = res.data.data.data;
            this.pageInfo.total = res.data.data.total;
          }
        })
        .finally(() => {
          this.loading = false;
        });
    },

    // PC 新增
    handleAdd() {
      this.isEdit = false;
      this.resetForm();
      this.dialogVisible = true;
    },
    // PC 编辑
    handleEdit(row) {
      this.isEdit = true;
      this.form = { ...row };
      this.dialogVisible = true;
    },
    // 提交新增/编辑
    submitForm() {
      this.$refs.formRef.validate((valid) => {
        if (!valid) return;
        this.loading = true;
        if (this.isEdit) {
          // 编辑
          api.sysConfig
            .edit({
              sys_id: this.form.id,
              system_value: this.form.system_value,
            })
            .then((res) => {
              if (res.data.code == 1000) {
                this.getList();
                this.dialogVisible = false;
              }
              this.loading = false;
            });
        } else {
          // 新增
          api.sysConfig.add(this.form).then((res) => {
            if (res.data.code == 1000) {
              this.getList();
              this.dialogVisible = false;
            }
            this.loading = false;
          });
        }
      });
    },
    // 删除
    handleDelete(row) {
      this.$confirm("确定删除该配置？", "提示", { type: "warning" }).then(
        () => {
          this.loading = true;
          api.sysConfig.del({ sys_id: row.id }).then((res) => {
            if (res.data.code == 1000) {
              this.getList();
            }
            this.loading = false;
          });
        }
      );
    },
    // 重置表单
    resetForm() {
      this.form = {
        id: "",
        cn_name: "",
        en_name: "",
        system_value: "",
        type: "",
      };
    },
    // 重置搜索
    resetSearch() {
      this.searchParams = { page: 1, page_size: 10, type: "" };
      this.getList();
    },
    // 每页条数
    handleSizeChange(val) {
      this.searchParams.page_size = val;
      this.getList();
    },
    // 切换页码
    handleCurrentChange(val) {
      this.searchParams.page = val;
      this.getList();
    },
    // 行点击查看详情
    handleRowClick(row) {
      this.detailForm = row;
      this.detailVisible = true;
    },

    // ============== 移动端 ==============
    // 打开新增
    openMobileAdd() {
      this.mobileAddForm = {
        cn_name: "",
        en_name: "",
        system_value: "",
        type: "",
      };
      this.mobileAddVisible = true;
    },
    // 提交新增
    async submitMobileAdd() {
      this.$refs.mobileAddRef.validate(async (valid) => {
        if (!valid) return;
        this.loading = true;
        try {
          let res = await api.sysConfig.add(this.mobileAddForm);
          if (res.data.code == 1000) {
            this.mobileAddVisible = false;
            this.getList();
          }
        } finally {
          this.loading = false;
        }
      });
    },
    // 打开编辑
    openMobileEdit(row) {
      this.mobileEditForm = JSON.parse(JSON.stringify(row));
      this.mobileEditVisible = true;
    },
    // 提交编辑
    async submitMobileEdit() {
      this.$refs.mobileEditRef.validate(async (valid) => {
        if (!valid) return;
        this.loading = true;
        try {
          let res = await api.sysConfig.edit({
            sys_id: this.mobileEditForm.id,
            system_value: this.mobileEditForm.system_value,
          });
          if (res.data.code == 1000) {
            this.mobileEditVisible = false;
            this.getList();
          }
        } finally {
          this.loading = false;
        }
      });
    },
    // 打开详情
    openMobileDetail(row) {
      this.mobileDetailRow = row;
      this.mobileDetailVisible = true;
    },
  },
};
</script>

<style scoped>
.coupon-table-container {
  padding: 20px;
}
.search-bar {
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  gap: 10px;
  margin-bottom: 20px;
}
.dialog-footer {
  text-align: right;
}

/* 移动端样式 */
.mobile-coupon-container {
  padding: 12px;
}
.mobile-search-group {
  display: flex;
  flex-direction: column;
  gap: 8px;
  margin-bottom: 12px;
}
.mobile-card-list {
  display: flex;
  flex-direction: column;
  gap: 10px;
  /* 新增：卡片列表和分页拉开间距 */
  margin-bottom: 16px;
}
.mobile-card {
  background: #fff;
  border-radius: 12px;
  padding: 14px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.05);
}
.card-header {
  display: flex;
  justify-content: space-between;
  margin-bottom: 10px;
}
.title {
  font-size: 16px;
  font-weight: 500;
}
.meta {
  font-size: 12px;
  color: #999;
  margin-top: 4px;
}
.type-tag {
  font-size: 12px;
  padding: 2px 6px;
  border-radius: 4px;
  font-weight: bold;
}
.type-tag.type1 {
  background: #e6f7ee;
  color: #00c48c;
}
.type-tag.type2 {
  background: #fef5e6;
  color: #ff9500;
}
.card-body {
  font-size: 13px;
  color: #666;
  line-height: 1.6;
  margin-bottom: 10px;
}
.card-footer {
  display: flex;
  justify-content: flex-end;
  align-items: center;
  gap: 8px;
}
/* 移动端分页样式 复制第二段 */
.mobile-pagination {
  text-align: right;
}
</style>


// WEBPACK FOOTER //
// src/pages/system/systemConfig.vue